/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openHomeworkDetailPage }
) => (
  <>
    <OverlayTrigger
      overlay={<Tooltip id="homework-detail-tooltip">Detay</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
        onClick={() => openHomeworkDetailPage(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Text/Article.svg")}
          />
        </span>
      </a>
    </OverlayTrigger>
  </>
);
  